"use client";

import { createContext, useEffect, useState } from "react";
import { usePathname } from "next/navigation";

export const CMSModal = createContext<any>(null);

export const CMSContext = ({ children }: { children: React.ReactNode }) => {
  const pathname = usePathname();

  const [user, setUser] = useState({});
  const [theme, setTheme] = useState<"light" | "dark">("light");
  const [selectedLocation, setSelectedLocation] = useState<string | null>(null);
  const [selectedLocationName, setSelectedLocationName] = useState<string | null>(null);

  const isAuthPage =
    pathname === "/login" || pathname === "/signup";

  useEffect(() => {
    const savedTheme = localStorage.getItem("theme") as "light" | "dark";
    const savedLocation = localStorage.getItem("selectedLocation");
    const savedLocationName = localStorage.getItem("selectedLocationName");

    if (savedTheme) {
      setTheme(savedTheme);
    } else if (window.matchMedia("(prefers-color-scheme: dark)").matches) {
      setTheme("dark");
    }

    if (savedLocation) {
      setSelectedLocation(savedLocation === "all" ? null : savedLocation);
    }
    if (savedLocationName) {
      setSelectedLocationName(savedLocationName);
    }
  }, []);

  const toggleTheme = () => {
    const newTheme = theme === "light" ? "dark" : "light";
    setTheme(newTheme);
    localStorage.setItem("theme", newTheme);
  };

  const handleLocationChange = (id: string | null, name?: string | null) => {
    setSelectedLocation(id);
    setSelectedLocationName(name || null);
    localStorage.setItem("selectedLocation", id || "all");
    if (name) {
      localStorage.setItem("selectedLocationName", name);
    } else {
      localStorage.removeItem("selectedLocationName");
    }
  };

  // 👇 Force light theme on auth pages
  const effectiveTheme: "light" | "dark" = isAuthPage ? "light" : theme;

  return (
    <CMSModal.Provider
      value={{
        user,
        setUser,
        theme: effectiveTheme,
        toggleTheme,
        selectedLocation,
        selectedLocationName,
        setSelectedLocation: handleLocationChange,
      }}
    >
      {children}
    </CMSModal.Provider>
  );
};
